// Placeholder data for the Team page until the /api/org endpoints exist.
// Shapes mirror what GET /api/org/mine and GET /api/org/members will return.

export const mockOrg = {
  id: 1,
  name: "Acme Inc.",
  myRole: "Admin",
  myUserId: 2,
  status: "Active",
  seatsPaid: 8,
  billingInterval: "Monthly",
  pricePerSeat: 12,
  currentPeriodEnd: "2026-11-02T00:00:00Z",
  cancelAtPeriodEnd: false,
};

export const mockMembers = [
  { userId: 1, name: "Sara Khan", email: "sara@acme.com", role: "Owner", joinedAt: "2026-09-02T00:00:00Z" },
  { userId: 2, name: "Daniel Reyes", email: "daniel@acme.com", role: "Admin", joinedAt: "2026-09-02T00:00:00Z" },
  { userId: 3, name: "Mei Chen", email: "mei.chen@acme.com", role: "Member", joinedAt: "2026-09-04T00:00:00Z" },
  { userId: 4, name: "Omar Farooq", email: "omar@acme.com", role: "Member", joinedAt: "2026-09-09T00:00:00Z" },
  { userId: 5, name: "Lena Fischer", email: "lena@acme.com", role: "Member", joinedAt: "2026-10-01T00:00:00Z" },
];

export const mockInvites = [
  { id: 101, email: "tom@acme.com", status: "Pending", sentAt: "2026-10-11T00:00:00Z", expiresAt: "2026-10-18T00:00:00Z" },
  { id: 102, email: "priya@acme.com", status: "Declined", sentAt: "2026-10-03T00:00:00Z", respondedAt: "2026-10-06T00:00:00Z" },
  { id: 103, email: "j.park@acme.com", status: "Expired", sentAt: "2026-09-28T00:00:00Z", expiresAt: "2026-10-05T00:00:00Z" },
];

// Owner's billing view on Manage Subscription (GET /api/org/mine + billing).
export const mockTeamBilling = {
  currentPeriodStart: "2026-10-02T00:00:00Z",
  currentPeriodEnd: "2026-11-02T00:00:00Z",
  billingEmail: "sara@acme.com",
  card: { brand: "Visa", last4: "4242", expMonth: 8, expYear: 2028 },
  // Set when a seat reduction is waiting for renewal.
  pendingSeatQuantity: null,
  invoices: [
    { id: "in_2", paidAt: "2026-10-02T00:00:00Z", seats: 8, amount: 72, status: "Paid", pdfUrl: null, viewUrl: null },
    { id: "in_1", paidAt: "2026-09-02T00:00:00Z", seats: 8, amount: 72, status: "Paid", pdfUrl: null, viewUrl: null },
  ],
};

// A member's own seat, shown on their Manage Subscription page.
export const mockMyMembership = {
  joinedAt: "2026-09-04T00:00:00Z",
  invitedBy: "Sara Khan",
};
